import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    size: { default: 'md' },
    color: { default: 'light' },
    name: { default: 'crescent' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})